import React from "react";
import { Menu } from "react-feather";
import { Link } from "react-router-dom";

import ROUTES from "../../routes/routes";

import "../../assets/css/services_menu.css";

export const ServicesMenu = () => {
  return (
    <>
      <section id="menu-services">
        <label for="id-show-menu" className="show-menu">
          <div className="nav-icon">
            <Menu size={30} />
          </div>
        </label>
        <input
          type="checkbox"
          id="id-show-menu"
          class="checkbox-menu"
          role="button"
        />
        <div className="menu-block">
          <ul className="navUL">
            <li>
              <Link to={ROUTES.PAYMENTS}>Valores a Pagar</Link>
            </li>
            <li>
              <Link to={ROUTES.PAYMENTS} className="btn disabled">
                Proximamente! Agenda de Turnos
              </Link>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};
